<template>
  <div>
    <!-------- start toast / snackbar------------------->
    <success-toast-component :SuccessToast="SuccessToast" @close="close" />
    <error-toast-component :ErrorToast="ErrorToast" @close="close" />
    <!-------- end toast / snackbar------------------->
    <!------------------section one------------------------>
    <v-row class="d-flex justify-space-between" flat>
      <v-col md="6" sm="6">
        <h1 class="heading-1">Coupon</h1>
      </v-col>

      <!--------------------------- add team --------------------------------------->
      <v-col md="6" sm="6">
        <v-card flat class="d-flex justify-end mt-2">
          <!-- <v-btn color="primary">Add new</v-btn> -->
          <v-btn
            color="primary"
            dark
            class="text_style px-7"
            depressed
            @click="(add_dialog = true), (SuccessToast = false)"
          >
            Add new
          </v-btn>
          <v-dialog
            v-model="add_dialog"
            persistent
            max-width="520"
            v-if="add_dialog"
          >
            <v-card>
              <AddCouponComponent
                :GetCoupon="GetCoupon"
                :addCouponDialog="add_dialog"
                @close="close"
                @fetchData="fetchData"
              ></AddCouponComponent>
            </v-card>
          </v-dialog>
        </v-card>
      </v-col>
    </v-row>
    <!------------------section two------------------------>
    <div class="my-3">
      <v-row class="mt-6">
        <v-col cols="12" md="4" sm="6">
          <v-card flat>
            <v-text-field
              dense
              outlined
              prepend-inner-icon="mdi-magnify"
              label="Search"
              v-model="search"
              hide-details
              single-line
            ></v-text-field>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <!------------------section three ( data table )------------------------>
    <div>
      <v-card class="mt-6" outlined>
        <v-data-table
          :headers="headers"
          :items="filteredData"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :page.sync="page"
          :items-per-page="displayedItemsPerPage"
          @page-count="pageCount = $event"
          hide-default-footer
          :sort-method="customSortIndex"
        >
          <!-- <template v-slot:[`item.index`]="{ index }">
            <span class="index_h1_text_style">
              <b> {{ index + itemsPerPage * (page - 1) + 1 }} </b>
            </span> -->
          <!-- </template> -->
          <template v-slot:[`item.Code`]="{ item }">
            <span class="index_head_text">
              {{ item.Code }}
            </span>
          </template>
          <template v-slot:[`item.StartDate`]="{ item }">
            <span class="index_head_text">
              {{ item.StartDate.slice(0, 10) }}
            </span>
          </template>
          <template v-slot:[`item.EndDate`]="{ item }">
            <span class="index_head_text">
              {{ item.EndDate.slice(0, 10) }}
            </span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span class="index_head_text">
              <v-switch
                v-model="item.IsActive"
                @change="ToggleStatus(item.Id)"
              ></v-switch>
            </span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="#A1A1A6" v-bind="attrs" v-on="on">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card style="border-radius: 1vw" flat>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="GetSingleCoupon(item), (SuccessToast = false)"
                  >
                    <v-icon color="#646464">mdi-pencil</v-icon>
                    <span class="ml-4 text_style action_dialog">Edit</span>
                  </v-btn>
                </v-list>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="DeleteData(item)"
                  >
                    <v-icon color="#646464">mdi-delete</v-icon>
                    <span class="ml-4 text_style action_dialog">Delete</span>
                  </v-btn>
                </v-list>
              </v-card>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
        ></v-pagination
      ></v-card>
    </div>
    <!-----------Delete dialog-------------------------->
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="text-h5"> Warning </v-card-title>
        <v-card-text class="index_span_2_style"
          >Are you sure you want to delete?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            :disabled="btnloader"
            @click="ConfirmDelete(deleteId)"
          >
            <span v-if="btnloader != true">Confirm</span>
            <v-progress-circular
              indeterminate
              v-else
              size="20"
              class="px-5"
              color="white"
              v-show="btnloader"
            ></v-progress-circular>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-----------start-coupon edit dialog-------------------------->
    <v-dialog v-model="editdialog" persistent max-width="600">
      <v-card>
        <div>
          <EditCouponComponent
            v-if="editdialog"
            :GetCoupon="GetCoupon"
            :editCouponDialog="editdialog"
            :GetSinglecoupon="GetSinglecoupon"
            @fetchData="fetchData"
            @close="close"
          ></EditCouponComponent>
        </div>
      </v-card>
    </v-dialog>
    <!-----------end-coupon edit dialog-------------------------->
  </div>
</template>

<script>
import AddCouponComponent from "../../components/Coupon/addcoupon.component.vue";
import EditCouponComponent from "../../components/Coupon/editcoupon.component.vue";
import SuccessToastComponent from "../../components/Toast/SuccessToast.component.vue";
import ErrorToastComponent from "../../components/Toast/ErrorToast.component.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    SuccessToastComponent,
    ErrorToastComponent,
    AddCouponComponent,
    EditCouponComponent,
  },
  data() {
    return {
      tableData: [],
      GetSinglecoupon: "",
      deleteId: "",
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      switch1: false,
      editdialog: false,
      add_dialog: false,
      snackbar: false,
      SuccessToast: false,
      ErrorToast: false,
      dialog: false,
      tableLoader: false, // data-table true or false
      btnloader: false,
      search: "",
      headers: [
        // { text: "#", value: "index"},
        { text: "Code", value: "Code", sortable: true },
        { text: "Start Date", value: "StartDate", sortable: true },
        { text: "End Date", value: "EndDate", sortable: true },
        { text: "Status", value: "status", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      DataTableOne: [],
    };
  },

  computed: {
    ...mapGetters(["GetCoupon"]),
    filteredData() {
      return this.tableData.filter((item) => {
        return Object.values(item).some(
          (val) =>
            (typeof val === "number" && this.search == val) ||
            (typeof val === "string" &&
              val.toLowerCase().includes(this.search.toLowerCase()))
        );
      });
    },
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.tableData.length
        : this.itemsPerPage;
    },
  },
  mounted() {
    this.fetchData();
    this.tableData = this.GetCoupon;
    this.tableLoader = true;
  },
  methods: {
    getIndexValue(item) {
      return item.index + this.itemsPerPage * (this.page - 1) + 1;
    },
    async ToggleStatus(Id) {
      await this.$store.dispatch("ToggleStatus", Id);
    },
    GetSingleCoupon(item) {
      this.editdialog = true;
      this.GetSinglecoupon = item;
    },
    async DeleteData(item) {
      this.dialog = true;
      this.deleteId = item.Id;
    },
    async fetchData() {
      this.tableLoader = true;
      this.$store.dispatch("GetCoupon").then(() => {
        this.tableData = this.GetCoupon;
        this.tableLoader = false;
      });
    },

    close() {
      this.editdialog = false;
      this.add_dialog = false;
      this.ErrorToast = false;
      this.SuccessToast = false;
    },
    ConfirmDelete(deleteId) {
      this.btnloader=true;
      this.$store.dispatch("DeleteCoupon", deleteId).then(() => {
        this.fetchData();
        this.dialog = false;
        this.btnloader=false;
        this.$swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Deleted Successfully",
            showConfirmButton: false,
            timer: 2500,
          });
      });
    },
  },
};
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}
</style>
